<!-- 采购部差价表 -->
<template>
  <div>
    <el-row>
      <el-col>
        <el-form size="small" :model="searchForm" ref="searchForm" :inline="true">
          <el-form-item label="供应商：">
            <el-input v-model="searchForm.SUPPLIER_NAME" @keyup.enter.native="search" clearable></el-input>
          </el-form-item>
          <el-form-item label="产品编码：">
            <el-input v-model="searchForm.PRODUCT_CODE" @keyup.enter.native="search" clearable></el-input>
          </el-form-item>
          <el-form-item label="产品名称：">
            <el-input v-model="searchForm.PRODUCT_NAME" @keyup.enter.native="search" clearable></el-input>
          </el-form-item>
          <el-form-item>
            <el-button class="btn" type="primary" @click="search" :loading="loading">筛选</el-button>
            <el-button class="btn" @click="exportData" :loading="loading">导出</el-button>
          </el-form-item>
        </el-form>
      </el-col>
    </el-row>
    <el-row>
      <el-col>
        <el-table border stripe :data="tableData" max-height="520">
          <el-table-column type="index" label="序号" width="50"></el-table-column>
          <el-table-column width="120" prop="SUPPLIER_ID" label="供应商编码"></el-table-column>
          <el-table-column min-width="200" prop="SUPPLIER_NAME" label="供应商名称"></el-table-column>
          <el-table-column min-width="200" prop="PRODUCT_CODE" label="产品编码"></el-table-column>
          <el-table-column min-width="200" prop="PRODUCT_NAME" label="产品名称"></el-table-column>
          <el-table-column width="100" prop="TYPE_UNIT" label="单位"></el-table-column>
          <el-table-column width="120" prop="REFERENCE_PRICE" label="业务参考价"></el-table-column>
          <el-table-column width="120" prop="SUPPLIER_PRICE" label="采购发生价"></el-table-column>
          <el-table-column width="100" prop="DISCOUNT_RATE" label="折扣率"></el-table-column>
          <el-table-column width="300" label="价格周期">
            <template slot-scope="scope">
              <span>{{ scope.row.START_DAY + ' ~ ' + scope.row.END_DAY }}</span>
            </template>
          </el-table-column>
        </el-table>
      </el-col>
    </el-row>
    <div class="pagination_box" style="text-align: right">
      <el-pagination @current-change="handleCurrentChange" :current-page.sync="currentPage" :page-size="pageSize"
        layout="total,prev, pager, next, jumper" :total="totalCount">
      </el-pagination>
    </div>
  </div>
</template>
<script>
import http from '@/assets/common/http';

export default {
  data() {
    return {
      searchForm: {},
      tableData: [],
      totalCount: 0,
      pageSize: 10,
      currentPage: 1,
      loading: false,
    };
  },
  created() {
    // 这里用来在设置中设置页面展示条目，文件在setting的generalSettings中，由前端控制条目，存储于localStorage中，key为SMP_PAGE_COUNT
    this.pageSize = Number(localStorage.getItem('SMP_PAGE_COUNT')) ? Number(localStorage.getItem('SMP_PAGE_COUNT')) : 10;
    if (this.PURCHASE_PRICE_DIFFERENCE_DATA_CONDITION.CONDITION) {
      this.searchForm = this.PURCHASE_PRICE_DIFFERENCE_DATA_CONDITION.CONDITION;
      this.tableData = this.PURCHASE_PRICE_DIFFERENCE_DATA_CONDITION.DATA;
      this.currentPage = this.PURCHASE_PRICE_DIFFERENCE_DATA_CONDITION.CURRENT_PAGE;
      this.totalCount = this.PURCHASE_PRICE_DIFFERENCE_DATA_CONDITION.TOTAL_COUNT;
    } else {
      this.currentPage = 1;
    }
    this.queryData();
  },
  computed: {
    PURCHASE_PRICE_DIFFERENCE_DATA_CONDITION() {
      return this.$store.state.PURCHASE_PRICE_DIFFERENCE_DATA_CONDITION;
    },
  },
  methods: {
    search() {
      this.currentPage = 1;
      this.queryData();
    },
    handleCurrentChange(e) {
      this.currentPage = e;
      this.queryData();
    },
    // -----------------------------拉取数据
    queryData() {
      const params = {
        SERVICE_ID: '10008',
        OTYPE: 52,
        GYS_ID: Number(sessionStorage.getItem('tcId')),
        PAGESIZE: this.pageSize,
        PAGEINDEX: this.currentPage - 1,
      };
      // 供应商名称
      if (this.searchForm.SUPPLIER_NAME) {
        params.SUPPLIER_NAME = this.searchForm.SUPPLIER_NAME;
      }
      // 产品编码
      if (this.searchForm.PRODUCT_CODE) {
        params.PRODUCT_CODE = this.searchForm.PRODUCT_CODE;
      }
      // 产品名称
      if (this.searchForm.PRODUCT_NAME) {
        params.PRODUCT_NAME = this.searchForm.PRODUCT_NAME;
      }
      this.loading = true;
      http.post(params).then((res) => {
        this.tableData = res[0].LIST;
        this.totalCount = res[0].TOTAL_COUNT;
        this.$store.dispatch('SET_PURCHASE_PRICE_DIFFERENCE_DATA_CONDITION', {
          CONDITION: this.searchForm,
          DATA: this.tableData,
          TOTAL_COUNT: this.totalCount,
          CURRENT_PAGE: this.currentPage,
        });
        this.loading = false;
      }).catch((error) => {
        this.loading = false;
        this.$message.show({ text: error, type: 'error' });
      });
    },
    exportData() {
      const params = {
        SERVICE_ID: '10008',
        OTYPE: 53,
        GYS_ID: Number(sessionStorage.getItem('tcId')),
      };
      // 供应商名称
      if (this.searchForm.SUPPLIER_NAME) {
        params.SUPPLIER_NAME = this.searchForm.SUPPLIER_NAME;
      }
      // 产品编码
      if (this.searchForm.PRODUCT_CODE) {
        params.PRODUCT_CODE = this.searchForm.PRODUCT_CODE;
      }
      // 产品名称
      if (this.searchForm.PRODUCT_NAME) {
        params.PRODUCT_NAME = this.searchForm.PRODUCT_NAME;
      }
      this.loading = true;
      http.post(params).then((res) => {
        this.$message.show({ text: '导出成功', type: 'success' });
        window.location.href = this.$util.getURLLocalHost(res.FILE_URL);
        this.loading = false;
      }).catch((error) => {
        this.loading = false;
        this.$message.show({ text: error, type: 'error' });
      });
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/tableManage/purchasePriceDifferenceTable.vue